
import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Form } from 'element-ui';
import { parsefilterDate } from '@/utils/filters/index';
import { isUpdatePossiable } from '@/api/reservationSchedulePart';
import { ReservationItemModule } from '@/store/modules/reservationItem';

@Component({
  components: {
  },
})
export default class extends Vue {
  @Prop({ required: true }) private selectedItem!: any;

  @Prop({ required: true }) private selectedIndex!: any;

  mounted() {
    if (this.selectedItem) {
      this.form = {
        ...this.form,
        ...this.selectedItem,
        startMonth: this.selectedItem.startDate.split('-')[0],
        startDay: this.selectedItem.startDate.split('-')[1],
        endMonth: this.selectedItem.endDate.split('-')[0],
        endDay: this.selectedItem.endDate.split('-')[1],
      };
    }
  }

  get itemForm() {
    return ReservationItemModule.form;
  }

  private form = {
    title: '',
    itemUid: '',
    startMonth: '',
    startDay: '',
    endMonth: '',
    endDay: '',
    settingUnitStatus: this.itemForm.settingUnitStatus,
    reservationItemDay: {},
    itemHour: [],
  }

  private loading = false;

  private validateStartMonth: any = (rule: any, value: any, callback: Function) => {
    const regExp = /^0{1}[1-9]{1}$|^[1-9]{1}$|1{1}[0-2]{1}$/;
    if (value === '') return callback(new Error('시작월을 입력하세요.'));
    if (!regExp.test(value)) return callback(new Error('월 형식(1~12)에 맞게 입력해주세요.'));
    return callback();
  }

  private validateStartDate: any = (rule: any, value: string, callback: Function) => {
    const regExp2 = /^0{1}[1-9]{1}$|^[1-9]{1}$|^1{1}[0-9]{1}$|^2{1}[0-9]{1}$|^3{1}[0-1]{1}$/;
    if (value === '') return callback(new Error('시작일을 입력하세요.'));
    if (!regExp2.test(value)) return callback(new Error('일 형식(1~31)에 맞게 입력해주세요.'));
    return callback();
  }

  private validateEndMonth: any = (rule: any, value: string, callback: Function) => {
    const regExp = /^0{1}[1-9]{1}$|^[1-9]{1}$|1{1}[0-2]$/;
    if (value === '') return callback(new Error('마침월을 입력하세요.'));
    if (!regExp.test(value)) return callback(new Error('월 형식(1~12)에 맞게 입력해주세요.'));
    return callback();
  }

  private validateEndDate: any = (rule: any, value: string, callback: Function) => {
    const regExp2 = /^0{1}[1-9]{1}$|^[1-9]{1}$|^1{1}[0-9]{1}$|^2{1}[0-9]{1}$|^3{1}[0-1]{1}$/;
    if (value === '') return callback(new Error('마침일을 입력하세요.'));
    if (!regExp2.test(value)) return callback(new Error('일 형식(1~31)에 맞게 입력해주세요.'));
    return callback();
  }

  private rules = {
    title: [
      {
        required: true,
        message: '타입이름을 입력해주세요.',
        trigger: 'blur',
      },
    ],
    startMonth: [
      {
        required: true,
        validator: this.validateStartMonth,
        trigger: 'blur',
      },
    ],
    startDay: [
      {
        required: true,
        validator: this.validateStartDate,
      },
    ],
    endMonth: [
      {
        required: true,
        validator: this.validateEndMonth,
      },
    ],
    endDay: [
      {
        required: true,
        validator: this.validateEndDate,
      },
    ],
  };

  private closeForm() {
    this.$emit('close');
  }

  private submitForm() {
    const regExp = /^[1-9]{1}$/;
    (this.$refs.form as Form).validate((valid: boolean) => {
      if (valid) {
        if (regExp.test(this.form.startMonth)) this.form.startMonth = parsefilterDate(this.form.startMonth);
        if (regExp.test(this.form.startDay)) this.form.startDay = parsefilterDate(this.form.startDay);
        if (regExp.test(this.form.endMonth)) this.form.endMonth = parsefilterDate(this.form.endMonth);
        if (regExp.test(this.form.endDay)) this.form.endDay = parsefilterDate(this.form.endDay);
        this.loading = true;
        isUpdatePossiable({
          itemUid: this.$route.params.uid,
          startDate: `${this.form.startMonth}-${this.form.startDay}`,
          endDate: `${this.form.endMonth}-${this.form.endDay}`,
        }).then((res) => {
          if (res.data) {
            this.loading = false;
            if (this.selectedItem != null && this.selectedIndex != null) {
              this.itemForm.schedulePart.splice(this.selectedIndex, 1);
              const updatedSchedulePart = {
                uid: this.selectedItem.uid,
                title: this.form.title,
                startDate: `${this.form.startMonth}-${this.form.startDay}`,
                endDate: `${this.form.endMonth}-${this.form.endDay}`,
                settingUnitStatus: this.itemForm.settingUnitStatus,
                reservationItemDay: { ...this.selectedItem.reservationItemDay },
                itemHour: [...this.selectedItem.itemHour],
                updateSchedule: [...this.selectedItem.updateSchedule],
                addStatus: false,
              };
              if (!this.selectedItem.uid) updatedSchedulePart.addStatus = true;
              this.itemForm.schedulePart.splice(this.selectedIndex, 0, updatedSchedulePart);
            } else {
              this.itemForm.schedulePart.push({
                title: this.form.title,
                startDate: `${this.form.startMonth}-${this.form.startDay}`,
                endDate: `${this.form.endMonth}-${this.form.endDay}`,
                settingUnitStatus: this.itemForm.settingUnitStatus,
                reservationItemDay: { ...this.itemForm.reservationItemDay },
                itemHour: [...this.itemForm.itemHour],
                updateSchedule: [],
                addStatus: true,
              });
            }
            this.$emit('getSchedulePartList');
            this.$emit('close');
          } else {
            this.$message({
              message: '해당 일정에 이미 예약된 이용자가 있습니다. \n 일정을 수정하시길 바랍니다.',
              type: 'warning',
            });
            this.loading = false;
          }
        });
      }
    });
  }
}
